import './search_bar.css';
import TextInput from '../text_input/text_input.tsx';
import { SearchIconSvg } from '../../../assets/icons.tsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

interface SearchBarProps {
    onChangeCallback: (value: string) => void;
    value: string;
}

function SearchBar({ onChangeCallback, value }: SearchBarProps) {
    function copyUrlToClipboard() {
        const url = new URL(window.location.href);
        navigator.clipboard
            .writeText(url.toString())
            .then(() => {
                console.debug('URL copied to clipboard:', url.toString());
            })
            .catch(err => {
                console.error('Failed to copy URL:', err);
            });
    }

    return (
        <div className="search_bar">
            <SearchIconSvg></SearchIconSvg>
            <div className="search_bar__input">
                <TextInput
                    placeHolder="Search for your sensor..."
                    value={value}
                    onChange={onChangeCallback}
                />
            </div>
            {value && (
                <button
                    type="button"
                    className="search_bar__copy_button"
                    onClick={copyUrlToClipboard}
                    title="Copy search URL"
                >
                    <FontAwesomeIcon icon={faCopy} />
                </button>
            )}
        </div>
    );
}

export default SearchBar;
